import React from 'react'
import { useSelector } from 'react-redux'
import { CHANGE_REQUEST_TYPE } from '@laputan/core'
import { CreateChangeRequestModal } from './CreateChangeRequestModal'
import { ModalType } from '../../states/modals/ModalType.constants'

const UpdateListingModal = () => {
  const { modalType, data } = useSelector(
    ({ modals }: { modals: any }) => modals
  )
  if (modalType !== ModalType.UPDATE_LISTING) {
    return null
  }
  const { title, id } = data
  return (
    <CreateChangeRequestModal
      header={`Provide Listing Info Request - ${title}`}
      type={CHANGE_REQUEST_TYPE.UPDATE_LISTING}
      otherRequestParams={{ listingId: id }}
    />
  )
}

export { UpdateListingModal }
